import { render, staticRenderFns } from "./teaStandard.vue?vue&type=template&id=36ae0d61"
import script from "./teaStandard.vue?vue&type=script&lang=js"
export * from "./teaStandard.vue?vue&type=script&lang=js"
import style0 from "./teaStandard.vue?vue&type=style&index=0&id=36ae0d61&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports